import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getEntries = async (page, page_size) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

    const config = {
        method: 'get',
        url: `/service/events_service/v1/events/event/clear/entry_list`,
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        params: { page, page_size }

    };
    try {
        const response = await axios.request(config);
        return response?.data;
    } catch (error) {
        console.error("Error fetching discount details:", error);
        throw error;
    }
};


export default getEntries;
